import {BASE_URL} from '@/services/api'
import {METHOD, removeAuthorization, request} from '@/utils/request'

let USER_DETAILS = `${BASE_URL}/user/detail`
let USER_UPDATE= `${BASE_URL}/user/update`
let USER_UPDATE_WITHOUT_ID= `${BASE_URL}/user/userUpdateWithoutId`
let USER_UPDATEPWD= `${BASE_URL}/user/updatePwd`
let LOGINED_LOGOUT =`${BASE_URL}/user/logout`
let UPLOAD_BACKGROUND =`${BASE_URL}/user/uploadBackground`
let USER_VERIFY = `${BASE_URL}/user/verifyPassword`
let USER_UPDATEPASSWORD = `${BASE_URL}/user/updatePassword`

let SAVE_FCMTOKEN =`${BASE_URL}/user/saveFcmToken`
let NOTICE_LIST =`${BASE_URL}/notice/getNoticeList`
let ALl_NOTICE_LIST =`${BASE_URL}/notice/getAllNoticeList`

let SEND_VERIFY_CODE = `${BASE_URL}/user/sendVerifyCode`
let CKECK_VERIFY_CODE = `${BASE_URL}/user/checkVerifyCode`

let DELETE_NOTICE = `${BASE_URL}/notice/deleteNotice`
let DELETE_SMART_PEEP_NOTICE = `${BASE_URL}/notice/deleteSmartPeepNotice`

let SAVE_REFRESH_TOKEN = `${BASE_URL}/user/saveRefreshToken`

let REFRESH_APP = `${BASE_URL}/user/refreshApp`


export async function SaveRefreshToken(params) {
  return request(SAVE_REFRESH_TOKEN, METHOD.POST, params)
}

export async function uploadBackground(params) {
  return request(UPLOAD_BACKGROUND, METHOD.POST,params,{
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

export async function GetUserDetails(id,type) {
  return request(USER_DETAILS, METHOD.POST, {
    id:id,
    type:type
  })
}

export async function UpdateUser(detail,type) {
  return request(USER_UPDATE, METHOD.POST, {
    detail:detail,
    type:type
  })
}

export async function UpdateUserWithoutId(params) {
  return request(USER_UPDATE_WITHOUT_ID, METHOD.POST, params)
}

export async function UpdateUserPwd(detail,type) {
  return request(USER_UPDATEPWD, METHOD.POST, {
    detail:detail,
    type:type
  })
}

export async function VerifyUserPwd(params) {
  return request(USER_VERIFY, METHOD.POST, params)
}

export async function UpdatePassword(params) {
  return request(USER_UPDATEPASSWORD, METHOD.POST, params)
}

export async function SendVerifyCode(params) {
  return request(SEND_VERIFY_CODE, METHOD.POST, params)
}

export async function CheckVerifyCode(params) {
  return request(CKECK_VERIFY_CODE, METHOD.POST, params)
}


/**
 * 退出登录 后端删除token
 */
export async function LoginedOut(params) {
  return request(LOGINED_LOGOUT, METHOD.POST, params)
}

/**
 * 退出登录 前端删除本地信息
 */
export function Logout() {
  localStorage.removeItem(process.env.VUE_APP_USER_KEY)
  localStorage.removeItem(process.env.VUE_APP_ROUTES_KEY)
  localStorage.removeItem(process.env.VUE_APP_PERMISSIONS_KEY)
  localStorage.removeItem(process.env.VUE_APP_ROLES_KEY)

  localStorage.removeItem("refreshtoken")
  removeAuthorization()
}

export async function SaveFcmToken(params) {
  return request(SAVE_FCMTOKEN, METHOD.POST, params)
}

export async function GetNoticeList() {
  return request(NOTICE_LIST, METHOD.POST)
}

export async function GetAllNoticeList() {
  return request(ALl_NOTICE_LIST, METHOD.POST)
}

//删除新着通知
export async function NoticeDelete(params) {
  return request(DELETE_NOTICE, METHOD.POST, params)
}

export async function SmartPeepNoticeDelete(params) {
  return request(DELETE_SMART_PEEP_NOTICE, METHOD.POST, params)
}

export async function refreshApp(params) {
  return request(REFRESH_APP, METHOD.POST, params)
}

